import { pathOr } from 'ramda';
import { shallow } from 'zustand/shallow';
import { useSportsbookStore } from '../../store';

export const selectCategories = (serviceId) =>
  pathOr({}, ['categories', serviceId, 'data']);

export const useCategories = (serviceId) =>
  useSportsbookStore(selectCategories(serviceId), shallow);
